module.exports = __webpack_public_path__ + "static/img/Tech_06.a533d688.png";